import { render, staticRenderFns } from "./ShowTransaction.vue?vue&type=template&id=37f9ac10&"
import script from "./ShowTransaction.vue?vue&type=script&lang=js&"
export * from "./ShowTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports